import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { useCountryContext } from '../../context';
import { UniversalFooter } from '../../components/universal-footer';
import ErrorFeature from '../../components/error-feature';
import { useUniversalHeader } from '../../hub-components/universal-header';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Error = ({
  error,
  status,
  headerStaticData
}) => {
  const country = useCountryContext();
  const [Header, setHeaderNavigationPath] = useUniversalHeader({
    variant: 'national',
    data: headerStaticData
  });
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(Header, {}), /*#__PURE__*/_jsx("main", {
      children: /*#__PURE__*/_jsx(ErrorFeature, {
        error: error,
        status: status
      })
    }), /*#__PURE__*/_jsx(UniversalFooter, {
      Link: Link,
      country: country,
      onFindACentre: () => setHeaderNavigationPath(['find-a-centre'])
    })]
  });
};

Error.defaultProps = {
  status: 404
};
export default Error;